import React from 'react'
import cx from 'classnames'

import { Arrow } from 'components/shared/Arrow/Arrow'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'

import { DropdownPropsContext } from './../../context'

import styles from './Menu.module.scss'

export const Menu = ({ children, className = undefined }) => {
  const {
    arrowRef,
    arrowStyle,
    floating,
    floatingStyle,
    hasArrow,
    isToggled,
  } = React.useContext(DropdownPropsContext)

  return (
    <TetherPortal isOpen={isToggled}>
      {isToggled ? (
        <div className={styles.content} ref={floating} style={floatingStyle}>
          {hasArrow && (
            <Arrow
              ref={arrowRef}
              size="medium"
              style={arrowStyle}
              theme="bright"
            />
          )}
          <ul className={cx(styles.menu, { [className]: Boolean(className) })}>
            {children}
          </ul>
        </div>
      ) : null}
    </TetherPortal>
  )
}
